import request from '@/utils/request'
/**
 *
 * 礼物管理
 *
 **/

// 获取列表接口
export const getGiftList = (params: any) => {
  return request({
    url: '/gift/page',
    method: 'get',
    params
  })
}

// 修改---启用禁用接口
export const enableOrDisableGift = (params: any) => {
  return request({
    url: `/gift/status/${params.status}`,
    method: 'post',
    params: { id:params.id,type: params.type }
  })
}

// 新增---新建礼物
export const addGift = (params: any) => {
  return request({
    url: '/gift',
    method: 'post',
    data: { ...params }
  })
}

// 修改---新建礼物
export const updateGift = (params: any) => {
  return request({
    url: '/gift',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryGiftById = (id: string | (string | null)[]) => {
  return request({
    url: `/gift/${id}`,
    method: 'get'
  })
}

// 删除接口
export const deleteGift = (params) => {
  return request({
    url: '/gift',
    method: 'delete',
    params: { ids:params.ids}
  })
}
